<template>
    <div class="reservation-completed">
        <div class="reservation-completed__tit">
            <div class="icon">
                <img v-if="$store.state.hospStore.hostNm == '대동맥혈관병원'" src="@/assets/resource/icon/point-icon02.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '뇌혈관병원'" src="@/assets/resource/icon/point-icon02-brain.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '엄마아기병원'" src="@/assets/resource/icon/point-icon02-mom.svg" class="" alt="">
                <img v-else-if="$store.state.hospStore.hostNm == '혈액암병원'" src="@/assets/resource/icon/point-icon02-blood.svg" class="" alt="">
            </div>
            <h3>진료예약 접수가 <span> 정상적으로 완료되었습니다.</span></h3>
        </div>

        <div class="table-box">
            <h3 class="bullet01">환자정보</h3>

            <ul class="table-box__list">
                <li class="table-box__item item2">
                    <div class="table-box__head">이름</div>
                    <div class="table-box__desc">{{ $store.state.reserveStore.reserve.patName }}</div>
                </li>
                <li class="table-box__item item2">
                    <div class="table-box__head">환자번호</div>
                    <div class="table-box__desc">{{ $store.state.reserveStore.reserve.ptNo }}</div>
                </li>
                <li class="table-box__item" :class="{item2: $store.state.reserveStore.reserve.rplFlag == 'N'}">
                    <div class="table-box__head" :style="{borderLeft: $store.state.reserveStore.reserve.rplFlag == 'Y' ? 'none' : '' }" >휴대전화</div>
                    <div class="table-box__desc" :style="{borderRight: $store.state.reserveStore.reserve.rplFlag == 'Y' ? 'none' : '' }">{{ $store.state.reserveStore.reserve.patHpNo }}</div>
                </li>
                <li class="table-box__item item2" v-if="$store.state.reserveStore.reserve.rplFlag == 'N'">
                    <div class="table-box__head">이메일</div>
                    <div class="table-box__desc">{{ $store.state.reserveStore.reserve.patEmail }}</div>
                </li>
            </ul>
        </div>

        <div class="table-box">
            <h3 class="bullet01">예약정보</h3>

            <ul class="table-box__list">
                <li class="table-box__item item2">
                    <div class="table-box__head">병원</div>
                    <div class="table-box__desc">{{'이대' + this.$store.getters.getHostNm}}</div>
                </li>
                <li class="table-box__item item2">
                    <div class="table-box__head">진료과</div>
                    <div class="table-box__desc">{{ $store.state.reserveStore.reserve.deptName }}</div>
                </li>
                <li class="table-box__item item2">
                    <div class="table-box__head">의료진</div>
                    <div class="table-box__desc">{{ $store.state.reserveStore.reserve.drName }} 교수</div>
                </li>
                <li class="table-box__item item2">
                    <div class="table-box__head">예약일시</div>
                    <div class="table-box__desc">{{ $store.state.reserveStore.reserve.medDt }}  {{ $store.state.reserveStore.reserve.medTm }}</div>
                </li>
            </ul>
        </div>

        <div class="mt20">
            <p class="c-red">※ 예약일시를 꼭 확인 후 내원해 주시기 바랍니다.</p>
        </div>

        <div class="botton-wrap mt40 nowrap" v-if="$store.state.reserveStore.reserve.rplFlag === 'N'">
            <router-link to="/kr/mypage/reservation/selectReservation" class="sub-button c-sub">예약 현황</router-link>
            <a href="javascript:;" class="sub-button c-main" @click="changeReservation">예약 변경</a>
            <a href="javascript:;" class="sub-button c-gray" @click="cancelResevation">예약 취소</a>
        </div>

        <kr_popup_change @successReservation="successReservation" ref="popupChange"/>
    </div>
</template>

<script>
export default {
    data() {
        return {
            // data
        }
    },
    mounted() {
        console.log(this.$store.state.reserveStore.reserve.rplFlag)
    },
    methods: {
        changeReservation() {
            this.$refs.popupChange.info = {
                RPY_PACT_ID: this.$store.state.reserveStore.reserve.RPY_PACT_ID,
                deptNm: this.$store.state.reserveStore.reserve.deptName,
                drName: this.$store.state.reserveStore.reserve.drName,
                drSid: this.$store.state.reserveStore.reserve.drSid,
                deptCd: this.$store.state.reserveStore.reserve.deptCd,
            }

            this.$refs.popupChange.popupBtn()
        },
        cancelResevation(){
            if (confirm('예약을 취소하시겠습니까?')) {
                const param = {
                    IN_PACT_ID : this.$store.state.reserveStore.reserve.RPY_PACT_ID,
                    IN_MED_DEPT_CD : this.$store.state.reserveStore.reserve.deptCd,
                }

                this.axios({
                    method: 'post',
                    url: this.api.mypage.reservationCancel,
                    params: param
                }).then(res => {
                    if(res.data.errormsg){
                        alert(res.data.errormsg)
                        return
                    }
                    alert('예약이 취소되었습니다.')
                    this.$router.push({path: '/kr/main'})
                }).catch(() => {
                    alert('오류가 발생했습니다.')
                    location.reload(true);
                })
            }
        },
        successReservation(){
            this.$forceUpdate()
            console.log(this.$store.state.reserveStore.reserve)
        }
    }
}

</script>